export const GET_ALL_ADMINISTRATOR_REQUEST = 'GET_ALL_ADMINISTRATOR_REQUEST';
export const GET_ALL_ADMINISTRATOR_SUCCESS = 'GET_ALL_ADMINISTRATOR_SUCCESS';
export const GET_ALL_ADMINISTRATOR_FAILURE = 'GET_ALL_ADMINISTRATOR_FAILURE';

export const ADD_ADMINISTRATOR_REQUEST = 'ADD_ADMINISTRATOR_REQUEST';
export const ADD_ADMINISTRATOR_SUCCESS = 'ADD_ADMINISTRATOR_SUCCESS';
export const ADD_ADMINISTRATOR_FAILURE = 'ADD_ADMINISTRATOR_FAILURE';

export const UPDATE_ADMINISTRATOR_REQUEST = 'UPDATE_ADMINISTRATOR_REQUEST';
export const UPDATE_ADMINISTRATOR_SUCCESS = 'UPDATE_ADMINISTRATOR_SUCCESS';
export const UPDATE_ADMINISTRATOR_FAILURE = 'UPDATE_ADMINISTRATOR_FAILURE';

export const GET_ADMINISTRATOR_BY_ID_REQUEST = 'GET_ADMINISTRATOR_BY_ID_REQUEST';
export const GET_ADMINISTRATOR_BY_ID_SUCCESS = 'GET_ADMINISTRATOR_BY_ID_SUCCESS';
export const GET_ADMINISTRATOR_BY_ID_FAILURE = 'GET_ADMINISTRATOR_BY_ID_FAILURE';

export const DELETE_ADMINISTRATOR_REQUEST = 'DELETE_ADMINISTRATOR_REQUEST';
export const DELETE_ADMINISTRATOR_SUCCESS = 'DELETE_ADMINISTRATOR_SUCCESS';
export const DELETE_ADMINISTRATOR_FAILURE = 'DELETE_ADMINISTRATOR_FAILURE';
